export default __webpack_public_path__ + "static/media/Web_08-01.1ed28a25.png";